import { render, staticRenderFns } from "./SaleLabel-list.vue?vue&type=template&id=7b9d59a9&scoped=true&lang=pug&"
import script from "./SaleLabel-list.vue?vue&type=script&lang=js&"
export * from "./SaleLabel-list.vue?vue&type=script&lang=js&"
import style0 from "./SaleLabel-list.vue?vue&type=style&index=0&id=7b9d59a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9d59a9",
  null
  
)

export default component.exports